import { useQuery } from '@tanstack/react-query';
import { getReferenceCurrency } from 'services/portfolios/portfolioService';

const useGetReferenceCurrency = (brUid: string, enable: boolean) => {
  return useQuery({
    queryKey: ['useGetReferenceCurrency', brUid],
    queryFn: () => getReferenceCurrency(brUid),
    enabled: !!brUid && enable,
  });
};

export default useGetReferenceCurrency;
